import { BackButton, ForwardButton } from 'components/button/button.styled'
import { LoadingContainer } from 'components/loadingContainer'
import { useLocationById } from 'hooks/admin/useLocations/useLocations'
import { BaseSyntheticEvent, useRef } from 'react'
import { useNavigate } from 'react-router-dom'

// eslint-disable-next-line no-restricted-imports
import { EventForm } from '../../form'
import { ButtonContainer, FormContent } from '../eventWizard.style'

interface ThirdStepProps {
    onPrevious: () => void
    eventData: Record<string, any>
    generatedEventId?: string
    isEditMode: boolean
    partnerId?: string
}

export const ThirdStep: React.FC<ThirdStepProps> = ({ onPrevious, eventData, generatedEventId, isEditMode, partnerId }: ThirdStepProps) => {
    const formRef = useRef<HTMLFormElement>(null)
    const navigate = useNavigate()

    const isEventLocation = !!eventData?.event_location_id
    const locationId = eventData?.event_location_id ?? eventData?.location_id ?? ''

    const { data: locationData, isLoading: isLocationLoading, error } = useLocationById(locationId, isEventLocation)

    const handleSave = async (e?: BaseSyntheticEvent<object, any, any>) => {
        e?.preventDefault()

        try {
            if (formRef.current) {
                // Use requestSubmit to trigger form validation and submit
                // This ensures all form inputs are properly processed before submission
                formRef.current.requestSubmit()
            }
        } catch (error) {
            console.error('Error saving event data:', error)
        }
    }

    const handleClose = () => {
        if (partnerId) {
            const url = `/admin/esemenyek/szervezet/${partnerId}`
            navigate(url)
        } else {
            navigate('/admin/esemenyek')
        }
    }
    console.log(locationData)
    console.log(eventData)
    return (
        <>
            <ButtonContainer hasbackbutton={true}>
                <BackButton icon="pi pi-arrow-left" label="Előző" onClick={onPrevious} />
                <ForwardButton icon="pi pi-arrow-right" iconPos="right" label="Mentés" onClick={handleSave} />
            </ButtonContainer>
            <LoadingContainer isLoading={isLocationLoading} error={error}>
                <FormContent>
                    <EventForm
                        initialData={eventData}
                        locationData={locationData}
                        generatedEventId={generatedEventId}
                        onClose={handleClose}
                        formRef={formRef}
                        partnerId={partnerId}
                    />
                </FormContent>
            </LoadingContainer>
        </>
    )
}
